// Central SEO configuration — target keywords, page titles, and descriptions for
// every static route on ransen.io. Titles are kept under 60 characters and
// descriptions under 160 characters for optimal SERP rendering.

const SITE_URL = 'https://ransen.io';
const abs = (path = '/') => `${SITE_URL}${path}`;

export const SITE_CONFIG = {
  name: 'Ransen',
  legalName: 'Ransen',
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.png`,
  description:
    'Ransen is an AI-powered digital marketing agency delivering full-funnel growth for global brands — SEO, paid media, LLMO, AEO, analytics, and conversion optimization.',
  sameAs: [
    'https://www.linkedin.com/company/ransen/',
    'https://www.facebook.com/people/Ransen-Marketing-Lab/61587451496930/',
    'https://www.instagram.com/ransen_marketing/',
    'https://ransen.ca',
  ],
  telephone: '+13435732394',
  email: 'marketing@ransen.ca',
  founded: '2018',
};

export const PAGE_SEO = {
  home: {
    title: 'Ransen — AI-Powered Digital Marketing Agency for Global Brands',
    description:
      'AI-powered digital marketing agency delivering SEO, paid media, LLMO, and full-funnel growth for ambitious brands worldwide. 320% avg ROI. Free strategy call.',
    canonical: abs('/'),
    keywords:
      'digital marketing agency, marketing agency, AI marketing agency, growth marketing agency, performance marketing agency, SEO agency, PPC agency, LLMO agency, best digital marketing agency, top marketing agency',
  },
  services: {
    title: 'Digital Marketing Services — SEO, Paid Media, LLMO | Ransen',
    description:
      'Full-service digital marketing: paid media, SEO, LLMO, AEO, web design, social media, video, and AI automation. Trusted by 150+ brands globally.',
    canonical: abs('/services'),
    keywords:
      'digital marketing services, marketing agency services, SEO services, PPC services, paid media agency, social media management, LLMO services, AEO services',
  },
  industries: {
    title: 'Industry Expertise — Ecommerce, SaaS, B2B, Healthcare | Ransen',
    description:
      'Vertical-specialized digital marketing programs for ecommerce, SaaS, healthcare, real estate, finance, professional services, and 12+ industries.',
    canonical: abs('/industries'),
    keywords:
      'digital marketing agency for ecommerce, SaaS marketing agency, B2B marketing agency, healthcare marketing agency, real estate marketing agency, industry-specific marketing',
  },
  locations: {
    title: 'Global Digital Marketing Agency — 40+ Cities Worldwide | Ransen',
    description:
      'Local digital marketing expertise in 40+ cities across North America, Europe, APAC, and the Middle East. Toronto, NYC, London, Berlin, Dubai, Singapore, more.',
    canonical: abs('/locations'),
    keywords:
      'digital marketing agency near me, marketing agency Toronto, marketing agency New York, marketing agency London, global marketing agency, international SEO agency',
  },
  caseStudies: {
    title: 'Case Studies — Real Growth Programs & Results | Ransen',
    description:
      'Real client outcomes across ecommerce, SaaS, real estate, and B2B. 4.6x ROAS, 68% lower CAC, 320% average ROI — with the dashboards and methodology to prove it.',
    canonical: abs('/case-studies'),
    keywords:
      'digital marketing case studies, marketing agency results, SEO case studies, PPC case studies, growth marketing case studies',
  },
  resources: {
    title: 'Marketing Resources — Guides, Playbooks, Frameworks | Ransen',
    description:
      'Free digital marketing resources: SEO checklists, LLMO playbooks, paid media benchmarks, and growth frameworks used by Ransen’s in-house team.',
    canonical: abs('/resources'),
    keywords:
      'digital marketing resources, marketing playbooks, SEO checklists, LLMO guide, paid media benchmarks, growth marketing frameworks',
  },
  blog: {
    title: 'Marketing Blog — SEO, LLMO, Paid Media Insights | Ransen',
    description:
      'In-depth guides on LLMO, SEO, paid media, attribution, and AI in marketing. Long-form playbooks from the Ransen team — updated weekly.',
    canonical: abs('/blog'),
    keywords:
      'digital marketing blog, SEO blog, LLMO guide, marketing insights, growth marketing blog, AI marketing blog',
  },
  about: {
    title: 'About Ransen — AI-Powered Growth Agency Team & Story',
    description:
      'Ransen is an AI-powered digital marketing agency founded in 2018. Meet the team, our methodology, and the mission behind 500+ growth programs shipped worldwide.',
    canonical: abs('/about'),
    keywords:
      'about Ransen, digital marketing agency team, AI marketing agency, growth agency story, marketing agency founders',
  },
  contact: {
    title: 'Contact Ransen — Book a Free Growth Strategy Call',
    description:
      'Book a free 30-minute strategy call with a senior Ransen strategist. Global time zones. No pitch decks — just a working diagnostic of your growth program.',
    canonical: abs('/contact'),
    keywords:
      'contact digital marketing agency, book strategy call, marketing agency consultation, free marketing audit, hire digital marketing agency',
  },
};
